import React from 'react';
import { format, isToday, isYesterday } from 'date-fns';

interface DateSeparatorProps {
  date: Date;
}

function labelFor(d: Date): string {
  if (isToday(d)) return 'Today';
  if (isYesterday(d)) return 'Yesterday';
  return format(d, 'EEEE, MMM d');
}

const DateSeparator: React.FC<DateSeparatorProps> = ({ date }) => {
  return (
    <div className="flex items-center my-3">
      <div className="flex-1 border-t border-border-secondary" />
      <span className="px-3 text-[11px] uppercase tracking-wide text-text-tertiary">
        {labelFor(date)}
      </span>
      <div className="flex-1 border-t border-border-secondary" />
    </div>
  );
};

export default DateSeparator;
